module.exports = __webpack_public_path__ + "img/data-quality-a-z-level-3.7d0aeeb8.svg";